import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/NavMenu';
import { Link } from "react-router-dom";
import Icon from "react-icons-kit";
import { calculator } from "react-icons-kit/fa/calculator";
import { user } from "react-icons-kit/fa/user";
import { star } from "react-icons-kit/fa/star";
import { users } from "react-icons-kit/fa/users";
import { barChart } from "react-icons-kit/fa/barChart";
import { box } from "react-icons-kit/feather/box";
import { mapPin } from 'react-icons-kit/feather/mapPin';
import { signOut } from 'react-icons-kit/fa/signOut';
import { home } from 'react-icons-kit/fa/home';
//import { clipboard } from 'react-icons-kit/fa/clipboard';
import { signIn } from "react-icons-kit/fa/signIn";
import { copy } from "react-icons-kit/icomoon";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "./NavMenu.css";
import fetchClient from '../common/FetchClient';
import { authContext } from '../../adalConfig';

export class NavMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showPricingCalculator: localStorage.getItem('Menu-PriceCalc') === 'true' || localStorage.getItem('Menu-PriceCalc') === true,
            showOrderPlanner: localStorage.getItem('Menu-OrderPlanner') === 'true' || localStorage.getItem('Menu-OrderPlanner') === true,
            showPriceMatrix: localStorage.getItem('Menu-Matrix') === 'true' || localStorage.getItem('Menu-Matrix') === true,
            showCheckIn: localStorage.getItem('Menu-CheckIn') === 'true' || localStorage.getItem('Menu-CheckIn') === true,
            showAny: false,
        };

        this.checkSecurity = this.checkSecurity.bind(this);
        this.logout = this.logout.bind(this);
    }

    /**
     * Logout user
     */
    logout() {
        this.setState({ showAny: false });
        localStorage.removeItem('Menu-PriceCalc');
        localStorage.removeItem('Menu-OrderPlanner');
        localStorage.removeItem('Menu-Matrix');
        localStorage.removeItem('Menu-CheckIn');
        localStorage.removeItem('Menu-SalesGoals');

        localStorage.removeItem('customer');
        localStorage.removeItem('address');
        localStorage.removeItem('customerName');
        localStorage.removeItem('addressName');
        localStorage.removeItem('street');
        localStorage.removeItem('city');
        localStorage.removeItem('state');
        localStorage.removeItem('zip');
        localStorage.removeItem('repName');
        localStorage.removeItem('repAccount');

        authContext.logOut();
    }

    login() {
        authContext.login();
    }

    checkSecurity() {
        var that = this;

        const userEnabledUrl = `/api/Users/CheckValidUser`;
        if (authContext.getCachedUser()) {
            fetchClient(userEnabledUrl, {
                params: {
                    azureToken: '',
                    username: authContext.getCachedUser().userName.replace("@empirepaper.com", '')
                }
            }).then(function (resp) {
                if (resp) {
                    if (resp.data[0] === "0") {
                        that.logout();
                    } else {
                        const url = `/api/SalesGoals/QuerySecurityMenu`;

                        fetchClient(url, {
                            params: {
                                azureToken: ''
                            }
                        }).then(function (resp) {
                            if (resp) {
                                that.setState({ showAny: true });
                                console.log(resp);
                                var data = resp.data.SecurityReqResp;
                                var menuItems = data.FunctionAccess;

                                var showSalesGoals = false;
                                var showCheckIn = false;
                                var showOrderPlanner = false;
                                var showPriceMatrix = false;
                                var showPricingCalculator = false;
                                var anySecurity = false;

                                try {
                                    menuItems.forEach((item) => {
                                        console.log('FunctionId: ' + item.FunctionId);
                                        console.log('Access: ' + item.AccessLevel);

                                        if (item.FunctionId === 'KPI-Sales1' && item.AccessLevel !== 'None') {
                                            localStorage.setItem('Menu-SalesGoals', true);
                                            showSalesGoals = true;
                                            anySecurity = true;
                                        } else if (item.FunctionId === 'CI-Menu1' && item.AccessLevel === 'None') {
                                            localStorage.setItem('Menu-SalesGoals', false);
                                        }

                                        if (item.FunctionId === 'CI-Menu1' && item.AccessLevel !== 'None') {
                                            localStorage.setItem('Menu-CheckIn', true);
                                            showCheckIn = true;
                                            anySecurity = true;
                                        } else if (item.FunctionId === 'CI-Menu1' && item.AccessLevel === 'None') {
                                            localStorage.setItem('Menu-CheckIn', false);
                                        }

                                        if (item.FunctionId === 'OP-Menu1' && item.AccessLevel !== 'None') {
                                            localStorage.setItem('Menu-OrderPlanner', true);
                                            showOrderPlanner = true;
                                            anySecurity = true;
                                        } else if (item.FunctionId === 'OP-Menu1' && item.AccessLevel === 'None') {
                                            localStorage.setItem('Menu-OrderPlanner', false);
                                        }

                                        if (item.FunctionId === 'MR-Menu1' && item.AccessLevel !== 'None') {
                                            localStorage.setItem('Menu-Matrix', true);
                                            showPriceMatrix = true;
                                            anySecurity = true;
                                        } else if (item.FunctionId === 'MR-Menu1' && item.AccessLevel === 'None') {
                                            localStorage.setItem('Menu-Matrix', false);
                                        }

                                        if (item.FunctionId === 'PC-Menu1' && item.AccessLevel !== 'None') {
                                            localStorage.setItem('Menu-PriceCalc', true);
                                            showPricingCalculator = true;
                                            anySecurity = true;
                                        } else if (item.FunctionId === 'PC-Menu1' && item.AccessLevel === 'None') {
                                            localStorage.setItem('Menu-PriceCalc', false);
                                        }
                                    });
                                } catch (e) {
                                    that.logout();
                                }

                                if (anySecurity === true) {
                                    //console.log('refreshing token');
                                }

                                that.setState({ showSalesGoals: showSalesGoals });
                                that.setState({ showAny: anySecurity });
                                that.setState({ showPricingCalculator: showPricingCalculator });
                                that.setState({ showOrderPlanner: showOrderPlanner });
                                that.setState({ showPriceMatrix: showPriceMatrix });
                                that.setState({ showCheckIn: showCheckIn });

                                console.log('Testing', authContext.getCachedUser(), that.state.showAny)
                            }
                        });
                    }
                }
            });
        }
        
    }

    componentDidMount() {
        this.checkSecurity();
    }

    render() {
        return (
            <Navbar inverse fixedTop fluid collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to={"/"} />
                    </Navbar.Brand>

                    <div className={this.state.showAny === true ? 'mobile-navbar-customer-container' : 'hidden'}>
                        <a href="/customer-search">
                            <Icon icon={user} className="mobile-navbar-customer-icon" />
                            <span className="mobile-navbar-customer">
                                {localStorage.getItem('customer') !== null ? '[' + localStorage.getItem('customer') + '] ' + localStorage.getItem('customerName') : 'No customer selected.'}
                            </span>
                        </a>
                    </div>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <LinkContainer to={"/"} exact>
                            <NavItem>
                                <Icon icon={home} />
                                <span className="glyphicon" /> Home
					        </NavItem>
                        </LinkContainer>
                        <LinkContainer to={"/sales-goals/"}>
                            <NavItem className={this.state.showSalesGoals === true ? '' : 'hidden'}>
                                <Icon icon={barChart} />
                                <span className="glyphicon" /> Sales Goals
					        </NavItem>
                        </LinkContainer>
                        <LinkContainer to={"/customer-search/"}>
                            <NavItem className={this.state.showAny === true ? '' : 'hidden'}>
                                <Icon icon={users} />
                                <span className="glyphicon" /> Customer Search
					        </NavItem>
                        </LinkContainer>
                        <LinkContainer to={"/product-search/"}>
                            <NavItem className={this.state.showAny === true ? '' : 'hidden'}>
                                <Icon icon={box} />
                                <span className="glyphicon" /> Item Search
					        </NavItem>
                        </LinkContainer>
                        <LinkContainer to={"/pricing-calculator"}>
                            <NavItem className={this.state.showPricingCalculator === true ? '' : 'hidden'}>
                                <Icon icon={calculator} />
                                <span className="glyphicon" /> Pricing Calculator
					        </NavItem>
                        </LinkContainer>
                        <LinkContainer to={"/order-planner"}>
                            <NavItem className={this.state.showOrderPlanner === true ? '' : 'hidden'}>
                                <Icon icon={copy} />
                                <span className="glyphicon" /> Order Planner
					        </NavItem>
                        </LinkContainer>
                        <LinkContainer to={"/price-matrix"}>
                            <NavItem className={this.state.showPriceMatrix === true ? '' : 'hidden'}>
                                <Icon icon={star} />
                                <span className="glyphicon" /> Matrix Price Ratings
					        </NavItem>
                        </LinkContainer>
                        <LinkContainer to={"/check-in"}>
                            <NavItem className={this.state.showCheckIn === true ? '' : 'hidden'}>
                                <Icon icon={mapPin} />
                                <span className="glyphicon" /> Customer Check-in
					        </NavItem>
                        </LinkContainer>
                    </Nav>
                    <Navbar.Text key="selectedCustomer" className={authContext.getCachedUser() === null ? 'hidden' : ''}>
                        <strong className="selectedCustomerLabel">Selected customer:</strong>
                    </Navbar.Text>
                    <Nav>
                        <NavItem disabled className={authContext.getCachedUser() === null ? 'hidden' : ''}>
                            {(() => {
                                if (localStorage.getItem('customer')) {
                                    return '[' + localStorage.getItem('customer') + '] '
                                }
                                else {
                                    return 'No customer selected.';
                                }
                            })()}
                            <br />
                            {(() => {
                                if (localStorage.getItem('customer')) {
                                    return localStorage.getItem('customerName');
                                }
                            })()}
                            <br />
                            {(() => {
                                if (localStorage.getItem('customer')) {
                                    return '[' + localStorage.getItem('address') + '] ';
                                }
                            })()}
                            <br />
                            {(() => {
                                if (localStorage.getItem('customer')) {
                                    return localStorage.getItem('addressName');
                                }
                            })()}
                            <br />
                            {(() => {
                                if (localStorage.getItem('customer')) {
                                    return localStorage.getItem('street');
                                }
                            })()}
                            <br />
                            {(() => {
                                if (localStorage.getItem('customer')) {
                                    return localStorage.getItem('city') + ', '
                                        + localStorage.getItem('state') + ', '
                                        + localStorage.getItem('zip');
                                }
                            })()}
                            <br />
                            {(() => {
                                if (localStorage.getItem('repName')) {
                                    if (localStorage.getItem('repName') === "Unassigned") {
                                        return localStorage.getItem('repName');
                                    } else {
                                        return '[' + localStorage.getItem("repAccount") + ']' + ' ' + localStorage.getItem('repName');
                                    }
                                }
                            })()}
                        </NavItem>
                        <LinkContainer to={"#"} onClick={this.logout}>
                            <NavItem className={authContext.getCachedUser() === null ? 'hidden' : ''}>
                                <Icon icon={signOut} />
                                <span className="logout-btn"> {authContext.getCachedUser() === null ? '' : authContext.getCachedUser().userName.replace("@empirepaper.com", '')} - Log Out</span>
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={"#"} onClick={this.login}>
                            <NavItem className={authContext.getCachedUser() === null ? '' : 'hidden'}>
                                <Icon icon={signIn} />
                                <span className="login-btn"> Log In</span>
                            </NavItem>
                        </LinkContainer>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default connect(
    state => state.navMenu,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(NavMenu);


// WEBPACK FOOTER //
// ./src/components/navigation/NavMenu.js